import { UnfoldMoreRounded } from "@mui/icons-material";
import {
  alpha,
  createTheme,
  CssBaseline,
  ThemeProvider as MuiThemeProvider,
  useTheme,
} from "@mui/material";
// import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { createContext, useContext, useMemo, useState } from "react";

const ThemeContext = createContext({
  mode: "light",
  toggleColorMode: () => {},
});
export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children, customTheme }) => {
  const [mode, setMode] = useState("light");

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    [mode]
  );

  // const theme = useMemo(() => {
  //   if (mode === "light") return lightTheme;

  //   // Create dark theme based on light theme
  //   return createTheme({
  //     ...lightTheme,
  //     palette: {
  //       ...lightTheme.palette,
  //       mode: "dark",
  //       background: {
  //         default: "#121212",
  //         paper: "#1e1e1e",
  //       },
  //       text: {
  //         primary: "#fff",
  //         secondary: "rgba(255, 255, 255, 0.7)",
  //         disabled: "rgba(255, 255, 255, 0.5)",
  //       },
  //     },
  //   });
  // }, [mode]);

  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {
        defaultProps: {
          variant: "outlined",
          IconComponent: UnfoldMoreRounded,
        },
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.shape.borderRadius,
            transition: theme.transitions.create([
              "border-color",
              "box-shadow",
            ]),
            "& .MuiOutlinedInput-notchedOutline": {},
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.action.active,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.primary.main,
            },
          }),
          select: ({ theme }) => ({
            padding: `${theme.spacing(2.0625)} ${theme.spacing(1.75)}`,
            minHeight: "0.4375em",
            "&:focus": {},
          }),
          icon: ({ theme }) => ({
            color: theme.palette.action.active,
          }),
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.shape.borderRadius / 2,
            margin: theme.spacing(0.25, 0.5),
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
            "&.Mui-selected": {
              backgroundColor: alpha(
                theme.palette.primary.main,
                theme.palette.action.selectedOpacity
              ),
              fontWeight: theme.typography.fontWeightMedium,
              "&:hover": {
                backgroundColor: alpha(
                  theme.palette.primary.main,
                  theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity
                ),
              },
            },
          }),
        },
      },
    },
    ...customTheme,
  });
  return (
    <ThemeContext.Provider value={colorMode}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
